<template>
  <div class="star-rating">
    <div class="stars">
      <span v-for="star in 5" :key="star" class="star">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient :id="`gradient-${star}-${uniqueId}`">
              <stop :offset="`${getStarFill(star)}%`" stop-color="#fbbf24" />
              <stop :offset="`${getStarFill(star)}%`" stop-color="#e5e7eb" />
            </linearGradient>
          </defs>
          <path
            :fill="`url(#gradient-${star}-${uniqueId})`"
            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          />
        </svg>
      </span>
    </div>
    <span v-if="showCount" class="rating-info">
      {{ rating.toFixed(1) }} <span class="count">({{ count }})</span>
    </span>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  rating: {
    type: Number,
    default: 0,
  },
  count: {
    type: Number,
    default: 0,
  },
  showCount: {
    type: Boolean,
    default: true,
  },
});

const uniqueId = Math.random().toString(36).substr(2, 9);

const getStarFill = (starPosition) => {
  const fillAmount = props.rating - (starPosition - 1);
  if (fillAmount >= 1) return 100;
  if (fillAmount <= 0) return 0;
  return fillAmount * 100;
};
</script>

<style scoped>
.star-rating {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.stars {
  display: flex;
  gap: 0.125rem;
}

.star {
  display: inline-block;
  width: 1rem;
  height: 1rem;
}

.star svg {
  width: 100%;
  height: 100%;
}

.rating-info {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.count {
  font-weight: 400;
  color: #6b7280;
}
</style>
